import React, { Component } from 'react';
import propTypes from 'prop-types';
import FontAwesome from 'react-fontawesome';
import Hammer from 'hammerjs';

import { findImagePath } from '~/Context/Global';
import { LANDSCAPE_IMAGE, PORTRAIT_IMAGE } from '~/Redux/Modules/Admin/Skins';
import { TABLET_WIDTH } from '~/Redux/Constants'; // this is temporary till we get S3 set up

import './SkinWrapper.scss';

const TropicalFlower = require('~/Components/Layout/SkinWrapper/Tropical-Flower.jpg');

const env = process.env.NODE_ENV || 'local';

class SkinWrapper extends Component {
  constructor(props) {
    console.log('SkinWrapper constructor');
    super(props);
    this.scale = 100;
  }

  componentDidMount = () => {
    const { currentSkin, src, setSrc, orientation, heartbeat } = this.props;
    const path = currentSkin
      ? findImagePath(currentSkin.images, orientation, window.innerWidth <= TABLET_WIDTH)
      : TropicalFlower;
    if (src !== path) {
      setSrc(path);
      this.preloadImage(path);
    }

    if (heartbeat) this.heartbeatInterval = setInterval(this.heartbeat, heartbeat);

    this.resize();
    window.addEventListener('resize', this.resize);

    if (window.innerWidth > TABLET_WIDTH) return;
    this.hammer = new Hammer.Manager(document.querySelector('#artful-client'), {
      touchAction: 'auto',
      inputClass: Hammer.SUPPORT_POINTER_EVENTS ? Hammer.PointerEventInput : Hammer.TouchMouseInput,
      recognizers: [
        [
          Hammer.Swipe,
          {
            direction: Hammer.DIRECTION_HORIZONTAL,
          },
        ],
      ],
    });
    this.hammer.on('swipeleft', () => {
      const { increment, currentType, start, end } = this.props;
      console.log('swipe detected');
      console.time('swipe');
      setTimeout(() => console.timeEnd('swipe'));
      increment(currentType, start, end);
    });
    this.hammer.on('swiperight', () => {
      const { decrement, currentType, start, end } = this.props;
      console.log('swipe detected');
      console.time('swipe');
      setTimeout(() => console.timeEnd('swipe'));
      decrement(currentType, start, end);
    });
  };

  componentWillUnmount = () => {
    if (this.hammer) {
      this.hammer.off('swipeleft');
      this.hammer.off('swiperight');
    }

    if (this.heartbeatInterval) clearInterval(this.heartbeatInterval);

    window.addEventListener('resize', this.resize);
  };

  componentDidUpdate = () => {
    this.resize();
  };

  heartbeat = () => {
    console.log('heartbeat');
    this.props.heartbeatFn(this.props.start);
  };

  preloadImage = src => {
    console.log('preload', src);
    let preloader = new Image();
    preloader.onload = () => {
      console.log('loaded', src);
      this.props.setLoaded(true, preloader.width);
      this.resize();
      this.setState({});
    };
    preloader.src = src;
  };

  componentWillReceiveProps = nextProps => {
    let { currentSkin, src, setSrc, orientation } = nextProps;
    if (window.innerWidth <= TABLET_WIDTH) orientation = PORTRAIT_IMAGE;
    const path = currentSkin
      ? findImagePath(currentSkin.images, orientation, window.innerWidth <= TABLET_WIDTH)
      : TropicalFlower;
    if (src !== path) {
      setSrc(path);
      this.preloadImage(path);
    }
  };

  resize = () => {
    if (!this.selector) return;

    this.scale = 100 / Math.ceil(this.selector.offsetWidth / this.props.imageWidth);
    if (this.props.orientation == PORTRAIT_IMAGE || window.innerWidth <= TABLET_WIDTH) {
      this.scale = Math.min(this.scale, 50);
    } else {
      this.scale = Math.min(this.scale, 100 / 3);
    }
  };

  render() {
    const {
      children,
      currentSkin,
      decrement,
      increment,
      currentType,
      start,
      end,
      showButtons,
      loaded,
      src,
    } = this.props;

    let style = {
      backgroundImage: `url(${src})`,
      backgroundSize: `${this.scale}%`,
    };

    if (
      (env == 'production' && currentSkin && currentSkin.id <= 92) ||
      (env == 'beta' && currentSkin && currentSkin.id <= 92) ||
      (env == 'staging' && currentSkin && currentSkin.id <= 67)
    ) {
      style.backgroundSize = window.innerWidth <= TABLET_WIDTH ? 'contain' : 'cover';
      style.backgroundPosition = 'center top';
    }

    if (!loaded || this.scale == 0) style['visibility'] = 'hidden';
    return (
      <div style={style} className="skin-wrapper" ref={r => (this.selector = r)}>
        {showButtons && [
          <button
            key="a"
            onClick={() => decrement(currentType, start, end)}
            className="decrement-button circle left"
          >
            <FontAwesome name="angle-left" />
          </button>,
          <button
            key="b"
            onClick={() => increment(currentType, start, end)}
            className="increment-button circle right"
          >
            <FontAwesome name="angle-right" />
          </button>,
        ]}
        {children}
      </div>
    );
  }
}

SkinWrapper.propTypes = {
  children: propTypes.node,
  currentSkin: propTypes.oneOfType([propTypes.bool, propTypes.object]),
  decrement: propTypes.func,
  increment: propTypes.func,
  currentType: propTypes.string,
  start: propTypes.object,
  end: propTypes.object,
  showButtons: propTypes.bool,
  src: propTypes.string,
  setSrc: propTypes.func,
  orientation: propTypes.string,
  heartbeat: propTypes.number,
  heartbeatFn: propTypes.func,
  setLoaded: propTypes.func,
  imageWidth: propTypes.number,
  loaded: propTypes.bool,
};

SkinWrapper.defaultProps = {
  showButtons: true,
  orientation: LANDSCAPE_IMAGE,
};

export default SkinWrapper;
